import { BaseModel } from "model/BaseModel";
import Produto from "./Produto";
import Pessoa from "../Pessoa";
import PlanoInspecao from "model/qualidade/PlanoInspecao";

export default class ProdutoFornecedor implements BaseModel {

    id: number;
    codigo: string = "";
    codigoProdutoFornecedor: string;
    produto: Produto|null;
    fornecedor: Pessoa|null;
    planoInspecao: PlanoInspecao | null;

    constructor(
        id = 0,
        codigoProdutoFornecedor = "",
        produto = null,
        fornecedor = null,
        planoInspecao = null
    ) {
        this.id = id;
        this.codigoProdutoFornecedor = codigoProdutoFornecedor;
        this.produto = produto;
        this.fornecedor = fornecedor;
        this.planoInspecao = planoInspecao;
    }

}